import { TIME_CONSTANTS } from '@/common/static_data/constants';

export function formatDateString(dateString) {
  return new Intl.DateTimeFormat('en-US').format(dateString.seconds * TIME_CONSTANTS.MILLISECONDS);
}
